﻿<script lang="ts" setup>
    import { inject, reactive, onMounted } from 'vue';
    import { AccountAccess } from '@cwd/Account/Account.access';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import ResponsesList from '@shared/components/List.vue';
    import { type Response } from './TextMessagesTypes';
    import { loadResponses } from './TextMessages.access';
    import { formatDateTime } from '@cwd/Shared/utils/formatDateTime';
    import PrePaid from './PrePaid.vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const accountAccess: AccountAccess = injectorAccess.injector.get(AccountAccess);

    const state = reactive<{
        responses: Response[];
        isBusy: boolean;
        showContactModal: boolean;
        contactId: string | null;
    }>({
        responses: [],
        isBusy: false,
        showContactModal: false,
        contactId: null,
    });

    onMounted(async () => {
        state.responses = await loadResponses();
    });

    const filterOptions = () => {
        return ['[Text]', '[Email]', '[FirstName]', '[LastName]', '[Name]'];
    };

    const addTextResponseClass = function (text: string) {
        let smsAnswerCode = accountAccess.state.currentAccount!.SmsAnswerCode;

        let regex1 = new RegExp('\\b' + smsAnswerCode + ' out ' + '\\b', 'gi');
        let regex2 = new RegExp('\\b' + smsAnswerCode + ' in ' + '\\b', 'gi');
        let regex3 = new RegExp('\\b' + smsAnswerCode + '\\b', 'gi');
        let regex4 = new RegExp('\\b' + 'out ' + '\\b', 'gi');
        let regex5 = new RegExp('\\b' + 'in ' + '\\b', 'gi');

        switch (true) {
            case regex1.test(text):
                return text.replace(regex1, function (macthed1) {
                    return '<span class="strong text-noitalic">' + macthed1 + '</span>';
                });
            case regex2.test(text):
                return text.replace(regex2, function (macthed2) {
                    return '<span class="strong text-noitalic">' + macthed2 + '</span>';
                });
            case regex3.test(text):
                return text.replace(regex3, function (macthed3) {
                    return '<span class="strong text-noitalic">' + macthed3 + '</span>';
                });
            case regex4.test(text):
                return text.replace(regex4, function (macthed4) {
                    return '<span class="strong text-noitalic">' + macthed4 + '</span>';
                });
            case regex5.test(text):
                return text.replace(regex5, function (macthed5) {
                    return '<span class="strong text-noitalic">' + macthed5 + '</span>';
                });
            default:
                return text;
        }
    };
</script>

<script lang="ts"></script>

<template>
    <ResponsesList
        :title="$Resources.SmsLastResponsesRecievedTab"
        :description="$Resources.SmsLastResponsesRecievedLabel"
        itemId="RecievedSmsId"
        :items="state.responses"
        :loading="state.isBusy"
        :filterKeys="filterOptions()">
        <template #header>
            <PrePaid></PrePaid>
        </template>
        <template #item="{ item, index }">
            <div class="flex-1">
                <h2 class="h4">
                    <router-link
                        v-if="item.ContactId"
                        :to="{
                            name: 'ResponseContact',
                            params: { contactId: item.ContactId },
                        }">
                        {{
                            item.FirstName || item.LastName
                                ? ((item.FirstName || '') + ' ' + (item.LastName || '')).trim()
                                : $Resources.NoContactNamePlaceholder
                        }}
                    </router-link>

                    <span v-else>+{{ item.From }}</span>
                </h2>

                <blockquote class="answer">
                    <p v-html="addTextResponseClass(item.Text)"></p>
                </blockquote>

                <p class="meta">
                    <span class="glyphicon glyphicon-time"></span>
                    <time :datetime="item.RecievedAt">{{ formatDateTime(item.RecievedAt) }}</time>
                </p>
            </div>
        </template>
    </ResponsesList>
</template>

<style>
    .answer {
        margin: var(--ug-spacing-sm) 0;
        border-width: 3px;
    }

    .answer p {
        margin: 0;
    }
</style>
